/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleselfcontrolweak4Inputs */



/**
* | output |
* | --- |
* | "Regulating your emotions in difficult situations can be tricky for you — a pause and mindful attention to your feelings will help you control your reaction." |
*
* @param {Eisubscaleselfcontrolweak4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleselfcontrolweak4 = /** @type {((inputs?: Eisubscaleselfcontrolweak4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleselfcontrolweak4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Regulating your emotions in difficult situations can be tricky for you — a pause and mindful attention to your feelings will help you control your reaction.")
	if (locale === "es") return /** @type {LocalizedString} */ ("A veces no te resulta fácil regular tus emociones en situaciones difíciles — una pausa y la atención consciente a lo que sientes te ayudarán a controlar tu reacción.")
	return /** @type {LocalizedString} */ ("Тебе бывает непросто регулировать свои эмоции в сложных ситуациях — пауза и осознанное внимание к своим чувствам помогут лучше контролировать реакцию.")
});
export { eisubscaleselfcontrolweak4 as "eiSubscaleSelfControlWeak" }